import { render, staticRenderFns } from "./ReCaptcha.vue?vue&type=template&id=110cd96a&scoped=true"
import script from "./ReCaptcha.vue?vue&type=script&lang=ts"
export * from "./ReCaptcha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110cd96a",
  null
  
)

export default component.exports